import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeHideableValue,
    doppeHideableValueCreateHidden
} from '../../client-server-common/types/doppe-hideable-value';
import {
    BymoTemplateSpeedDialAutoComplete
} from '../../components/bymo-templates/bymo-template-speed-dial/bymo-template-speed-dial-common';
import {DoppeActionTypeContentSpecialSettingsMetadata} from "../../client-server-common";
import {Values} from '@wix/devzai-utils-common';

/**
 * Defines the context from which the search panel is opened.
 * - Page: Opened from a specific page, show only that page's actions
 * - Menu: Opened from the navigation menu, accumulate actions from all pages with showActionsInSearch enabled
 */
export const SpeedDialSearchOpeningContext = {
    Page: 'Page',
    Menu: 'Menu',
} as const;

export type SpeedDialSearchOpeningContext = Values<typeof SpeedDialSearchOpeningContext>;

export namespace DoppeActionTypeSpeedDial {
    export interface ActionSettings {
        autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete;
        showFullScreenAutoCompleteOnMobile: boolean;
        searchPlaceholder: DoppeHideableValue<string>;
        showActionsInSearch: boolean;
        showLinksInSearch: boolean;
        /**
         * The context from which the search panel is opened.
         * Controls whether to show actions from the current page only (Page) or
         * accumulate from all pages with showActionsInSearch enabled (Menu).
         * @default SpeedDialSearchOpeningContext.Page
         */
        searchOpeningContext: SpeedDialSearchOpeningContext;
    }
}

export const doppeActionTypeSpeedDial = doppeActionTypeDefineMetadata<DoppeActionTypeSpeedDial.ActionSettings>({
    id: 'io.bymo.action/speed-dial',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        showFullScreenAutoCompleteOnMobile: false,
        autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete.OnInputSearch,
        searchPlaceholder: doppeHideableValueCreateHidden(''),
        showActionsInSearch: false,
        showLinksInSearch: true,
        searchOpeningContext: SpeedDialSearchOpeningContext.Page
    }),
    canRenderInPage: true,
    actionSettingsMetadata: {
        contentSettingsMetadata: DoppeActionTypeContentSpecialSettingsMetadata.Ignored,
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false
});